import type { IPatientPrimaryCareProvider } from "../../../core/ports/driver/VisitNotesService";

export const buildPatientPrimaryCareProviderUrl = ({
  route,
  clinicId,
  patientId,
}: {
  route: string;
  clinicId: number;
  patientId: number;
}): string =>
  route
    .replace("{clinic_id}", clinicId.toString())
    .replace("{patient_id}", patientId.toString());

/**
 * Parses both the direct provider payload and the API's stored-field envelope.
 * `null` is a valid response when no PCP has been saved; `undefined` means the
 * response was malformed.
 */
export const primaryCareProviderFromApiResponse = (
  response: any
): IPatientPrimaryCareProvider | null | undefined => {
  const data = response?.data !== undefined ? response.data : response;
  if (data === null) return null;

  const hasProviderEnvelope =
    data &&
    typeof data === "object" &&
    Object.prototype.hasOwnProperty.call(data, "primary_care_provider");
  const extraInfo =
    data && typeof data.extra_info === "object" && data.extra_info !== null
      ? data.extra_info
      : null;
  const hasExtraInfoProvider =
    extraInfo &&
    Object.prototype.hasOwnProperty.call(extraInfo, "primary_care_provider");
  const provider = hasProviderEnvelope
    ? data.primary_care_provider
    : hasExtraInfoProvider
    ? extraInfo.primary_care_provider
    : data?.provider ?? data;

  if (provider === null) return null;
  if (typeof provider === "string") {
    const name = provider.trim();
    return name ? { name } : null;
  }
  if (!provider || typeof provider !== "object") return undefined;
  if (provider.name === null) return null;
  return typeof provider.name === "string" && provider.name.trim()
    ? { ...provider, name: provider.name.trim() }
    : undefined;
};
